import { Row } from "@/common/custom-lists/ListView";
import { useState } from "react";
import { connect } from "react-redux";

const ReportClientsRow = ({ organisation, updateApplied, isApplied }) => {
	const [applied, setApplied] = useState(isApplied || false);
	return (
		<Row
			actionColumns={[0]}
			columns={[
				" ",
				organisation?.name,
				<div
					className="parent-container m-0"
					style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}
				>
					<label
						className="css-input switch switch-sm switch-success"
						style={{ margin: 0 }}
					>
						<input
							type="checkbox"
							checked={applied}
							onChange={(e) => {
								setApplied(e.target.checked);
								updateApplied(e.target.checked);
							}}
						/>
						<span />{" "}
					</label>
				</div>,
				" ",
			]}
		/>
	);
};

const mapStateToProps = (state) => {};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ReportClientsRow);
